import get from 'lodash/get';

import {
  BUILDING_LIST_REQUESTED,
  BUILDING_REQUESTED,
  BUILDING_RESIDENTS_REQUESTED,
  BUILDING_SR_CATEGORIES_REQUESTED,
  BUILDING_STAFF_REQUESTED,
  BUILDING_UNITS_SUCCESS,
  BUILDING_YARDI_INFO_REQUESTED,
  CLEAR_BUILDING_EXTERNAL_ACCOUNT,
  CLEAR_BUILDING_LIST_REQUESTED,
  GET_ALL_BUILDING_ACCOUNTING_ACCOUNTS_SUCCESS,
  GET_ALL_BUILDING_AC_ACCOUNTS_SUCCESS,
  GET_ALL_BUILDING_EE_ACCOUNTS_SUCCESS,
  GET_ALL_BUILDING_EXTERNAL_LINKS_SUCCESS,
  GET_ALL_BUILDING_PAYMENTS_ACCOUNTS_SUCCESS,
  GET_BUILDING_2N_ACCOUNT_SUCCESS,
  GET_BUILDING_AKUVOX_ACCOUNT_SUCCESS,
  GET_BUILDING_APPFOLIO_ACCOUNT_SUCCESS,
  GET_BUILDING_BRIVO_SITE_ID_SUCCESS,
  GET_BUILDING_DELIVERY_TYPES_SUCCESS,
  GET_BUILDING_MDS_ACCOUNT_SUCCESS,
  GET_BUILDING_MRI_ACCOUNT_SUCCESS,
  GET_BUILDING_OPERATIONS_SUCCESS,
  GET_BUILDING_PAYMENTS_ACCOUNT_SUCCESS,
  GET_BUILDING_YARDI_ACCOUNT_SUCCESS,
  GET_CAMERAS_SUCCESS,
  GET_DELIVERY_SNAPSHOT_DATA_SUCCESS,
  GET_DOORS_OPENING_LOG_SUCCESS,
  GET_DOORS_SUCCESS,
  GET_INTEGRATIONS_STATUS_SUCCESS,
  GET_LEASING_SETTINGS_SUCCESS,
  GET_PEOPLE_IN_BUILDING_SUCCESS,
  GET_PERSON_DETAILS_SUCCESS,
  GET_PROPERTY_SETTINGS_SUCCESS,
  GET_REMOTE_DOORMAN_SETTINGS_SUCCESS,
  GET_SERVICE_REQUESTS_PRIORITIES_SUCCESS,
  GET_UNITS_WITH_CONTACTS_SUCCESS,
  PUT_INTEGRATIONS_STATUS_SUCCESS,
  PUT_PROPERTY_SETTINGS_SUCCESS,
  PUT_REMOTE_DOORMAN_SETTINGS_SUCCESS,
  RESEND_INVITE_TO_ALL_RESIDENTS_INFO_SUCCESS,
  SET_BUILDING_EXTERNAL_ACCOUNT,
  UNIT_REMOVE_SUCCEEDED,
  UPDATE_BUILDING_OPERATIONS_SUCCESS,
} from '../actionConstants';

import { isAdmin } from '../utils';
import { arrayToObject, mergeObjects } from './utils';

const defaultState = {};

export default (state = defaultState, action) => {
  let newState;
  switch (action.type) {
    case UNIT_REMOVE_SUCCEEDED: {
      const units = get(state, `${action.buildingId}.units`, []).filter(
        (item) => item !== action.unitId,
      );
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          units,
        },
      };
    }
    case BUILDING_REQUESTED: {
      const buildingId = get(action, 'payload.data.id', null);

      if (!buildingId) return state;

      const doors = get(action, 'payload.data.doors', []);
      const displayedDoors = isAdmin()
        ? doors
        : doors.filter((door) => !door.disabled);
      return {
        ...state,
        [buildingId]: {
          ...state[buildingId],
          ...action.payload.data,
          doors: displayedDoors,
        },
      };
    }
    case BUILDING_LIST_REQUESTED: {
      const { payload, withReset } = action;
      const buildings = payload?.data || [];
      if (withReset) return arrayToObject(buildings);
      if (buildings?.length < 1) return state;
      newState = mergeObjects(state, arrayToObject(buildings));
      return {
        ...newState,
      };
    }

    case CLEAR_BUILDING_LIST_REQUESTED:
      return defaultState;

    case BUILDING_SR_CATEGORIES_REQUESTED: {
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          serviceRequestCategories: action.payload.data,
        },
      };
    }
    case BUILDING_STAFF_REQUESTED: {
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          staff: action?.payload?.data,
        },
      };
    }
    case BUILDING_RESIDENTS_REQUESTED: {
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          residents: action?.payload?.data,
        },
      };
    }
    case GET_PEOPLE_IN_BUILDING_SUCCESS: {
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          people: action.people,
        },
      };
    }
    case GET_PERSON_DETAILS_SUCCESS: {
      const { buildingId, personId, res } = action;
      return {
        ...state,
        [buildingId]: {
          ...state[buildingId],
          personDetails: {
            [personId]: res?.data,
          },
        },
      };
    }
    case RESEND_INVITE_TO_ALL_RESIDENTS_INFO_SUCCESS: {
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          resendInviteToAllResidentsInfo: action.res.data,
        },
      };
    }
    case BUILDING_YARDI_INFO_REQUESTED: {
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          yardi: action.payload.data,
        },
      };
    }
    case BUILDING_UNITS_SUCCESS: {
      const units =
        get(action, 'res.data.data', null) || get(action, 'res.data', []);
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          units: units.map((item) => item.id),
        },
      };
    }
    case GET_UNITS_WITH_CONTACTS_SUCCESS: {
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          units: action.res.data.map((item) => item.id),
        },
      };
    }
    case GET_DOORS_OPENING_LOG_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          doorsOpeningLog: action.res.data,
        },
      };
    case GET_DOORS_SUCCESS: {
      const { res, buildingId } = action;
      const doors = res.data.data || res.data || [];
      if (!buildingId) return state;
      return {
        ...state,
        [buildingId]: {
          ...state[buildingId],
          doors: isAdmin() ? doors : doors.filter(({ disabled }) => !disabled),
        },
      };
    }

    case SET_BUILDING_EXTERNAL_ACCOUNT:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          currentExternalAccount: action.res.data,
        },
      };
    case CLEAR_BUILDING_EXTERNAL_ACCOUNT:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          currentExternalAccount: null,
        },
      };
    case GET_BUILDING_BRIVO_SITE_ID_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          accessControlAccounts: {
            ...state[action.buildingId].accessControlAccounts,
            brivoSiteId: action.res.data,
          },
        },
      };
    case GET_BUILDING_PAYMENTS_ACCOUNT_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          buildingPaymentsAccount: action.res.data,
        },
      };
    case GET_ALL_BUILDING_AC_ACCOUNTS_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          accessControlAccounts: action.res.data,
        },
      };
    case GET_ALL_BUILDING_EE_ACCOUNTS_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          camerasAccounts: action.res.data,
        },
      };
    case GET_ALL_BUILDING_EXTERNAL_LINKS_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          externalLinks: action.res.data,
        },
      };
    case GET_ALL_BUILDING_PAYMENTS_ACCOUNTS_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          paymentsAccounts: action.res.data,
        },
      };
    case GET_ALL_BUILDING_ACCOUNTING_ACCOUNTS_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          accountingAccounts: action.res.data,
        },
      };
    case GET_PROPERTY_SETTINGS_SUCCESS:
    case PUT_PROPERTY_SETTINGS_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          propertySettings: action.res.data,
        },
      };
    case GET_LEASING_SETTINGS_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          leasingSettings: action.res.data,
        },
      };
    case GET_REMOTE_DOORMAN_SETTINGS_SUCCESS:
    case PUT_REMOTE_DOORMAN_SETTINGS_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          remoteDoormanSettings: action.res.data,
        },
      };
    case GET_INTEGRATIONS_STATUS_SUCCESS:
    case PUT_INTEGRATIONS_STATUS_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          integrationsStatus: action.res.data,
        },
      };
    case GET_DELIVERY_SNAPSHOT_DATA_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          deliverySnapshotData: action.res.data,
        },
      };
    case GET_BUILDING_DELIVERY_TYPES_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          deliveryTypes: action.res.data,
        },
      };
    case GET_BUILDING_2N_ACCOUNT_SUCCESS:
    case GET_BUILDING_AKUVOX_ACCOUNT_SUCCESS:
    case GET_BUILDING_YARDI_ACCOUNT_SUCCESS:
    case GET_BUILDING_MRI_ACCOUNT_SUCCESS:
    case GET_BUILDING_APPFOLIO_ACCOUNT_SUCCESS:
    case GET_BUILDING_MDS_ACCOUNT_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          updateAccountData: action.res.data,
        },
      };
    case GET_BUILDING_OPERATIONS_SUCCESS:
    case UPDATE_BUILDING_OPERATIONS_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          buildingOperations: action.res.data,
        },
      };
    case GET_CAMERAS_SUCCESS:
      if (!action.buildingId) return state;
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          cameras: action.res.data,
        },
      };
    case GET_SERVICE_REQUESTS_PRIORITIES_SUCCESS:
      return {
        ...state,
        [action.buildingId]: {
          ...state[action.buildingId],
          serviceRequestPriorities: action.res.data,
        },
      };
    default:
      return state;
  }
};
